module.exports = __webpack_public_path__ + "img/bh.90ad3cbd.svg";